/** The malware scan flagged this file's current version: it cannot be opened or shared. */
export function isMalwareBlocked(file) {
  return file?.malwareScanStatus === 'THREATS_FOUND';
}

export const MALWARE_BLOCKED_MESSAGE =
  'The malware scan flagged this file. It is blocked: nobody can download, preview or share it. Delete it, or ask the person who uploaded it for a clean copy.';
